import { graphql } from "../generated";

export const GetCurrentCompany = graphql(`
  query GetCurrentCompany {
    currentCompany @rest(type: "RestCompany", path: "company", endpoint: "v3") {
      id
      plan
      name
      billingPeriod
      createdAt
      lastTimePlanChanged
      trial {
        callTotalSeconds
        hasTrialCallLimits
        trialEnd
      }
      provider
      tierLevel
      address {
        city
        country
        state
        zip
      }
    }
  }
`);
